import { Textarea as Textarea$ } from "@chakra-ui/react";
import { useField } from "formik";
import { FormProperties } from "../FormProperties";

export function Textarea(props: FormProperties) {
  const [field, meta] = useField(props.fieldName);
  return (
    <Textarea$
      id={props.fieldName}
      onChange={field.onChange}
      value={field.value}
      w={"100%"}
      disabled={props.disabled}
      variant="filled"
      placeholder={props.placeholder}
      isInvalid={meta.touched && meta.error !== undefined}
    />
  );
}
